import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./chevron.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Chevron = ({
  children,
  className,
  Header,
  isDefaultOpen = false,
  alwaysKeepOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(isDefaultOpen || alwaysKeepOpen);

  const toggleState = () => {
    setIsOpen((prevState) => !prevState);
  };

  useEffect(() => {
    if (isDefaultOpen || alwaysKeepOpen) {
      setIsOpen(true);
    }
  }, [isDefaultOpen, alwaysKeepOpen]);

  return (
    <div className={`chevron relative ${className}`}>
      <div
        className="flex items-center pl-0 pr-4 pt-2 pb-[7px] ipad:pr-0 rtl:pr-0 cursor-pointer select-none"
        onClick={() => (alwaysKeepOpen ? setIsOpen(true) : toggleState())}
      >
        {Header}
        <motion.div
          className="toggleIcon inline-flex items-center justify-center mr-4 ipad:mr-0"
          style={{ transformOrigin: "center center" }}
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.25, ease: "easeInOut" }}
        >
          <FontAwesomeIcon
            icon={faChevronDown}
            className="flex text-[#9AA6AC] text-xs mt-[-5px]"
          />
        </motion.div>
      </div>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="chevron-content"
            className={`content open overflow-hidden`}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              height: { duration: 0.3, ease: "easeInOut" },
              opacity: { duration: 0.2, ease: "easeInOut" },
            }}
          >
            <motion.div
              initial={{ y: -6 }}
              animate={{ y: 0 }}
              exit={{ y: -6 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
            >
              {children}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Chevron;
